import 'react-select/dist/react-select.css';

import React, { Component } from 'react';
import Select from 'react-select';

class SearchFilter extends Component {

  _handleOptionClick = (value) => {
    this.props.onChange(value.map(v => v.value));
  };

  render() {
    const { title, values = [], selected = [] } = this.props;

    return (
      <div className='c-SearchFilter__property'>
        <div className='c-SearchFilter__property-title'>
          {title}
        </div>

        <Select
          multi
          name='form-field-name'
          value={selected}
          options={values.map(v => ({ value: v, label: v }))}
          onChange={this._handleOptionClick}
        />

      </div>
    );
  }
}

export default SearchFilter;



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/product/js/SearchFilter.js